import { Routes } from '@angular/router';
import { authGuard } from './core/guards';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./features/login-management/login-page').then((m) => m.LoginPage),
  },
  {
    path: 'activate-account',
    loadComponent: () => import('./features/activate-account/activate-page').then((m) => m.ActivatePage),
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./features/reset-password/reset-password-page').then((m) => m.ResetPasswordPage),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./layout/main-layout/main-layout').then((m) => m.MainLayout),
    children: [
      {
        path: 'home',
        loadComponent: () => import('./features/home/home').then((m) => m.Home),
      },
      {
        path: 'alta-trabajador',
        loadComponent: () => import('./features/alta-trabajador/alta-trabajador').then((m) => m.AltaTrabajador),
      },
      {
        path: 'alta-trabajador/:id',
        loadComponent: () => import('./features/alta-trabajador/alta-trabajador').then((m) => m.AltaTrabajador),
      },
      {
        path: 'gestion-documentos',
        loadComponent: () => import('./features/gestion-documentos/gestion-documentos').then((m) => m.GestionDocumentos),
      },
      {
        path: 'visualizar-personal',
        loadComponent: () => import('./features/visualizar-personal/visualizar-personal').then((m) => m.VisualizarPersonal),
      }

      // {
      //     path: 'dashboard',
      //     loadComponent: () => import('./features/dashboard/dashboard.page').then(m => m.DashboardPage)
      // }
    ],
  },
];
